<template>
    <BDropdownItem
        href="#"
        v-on:click.prevent="process"
        :disabled="isProcessing"
    >
        <i class="fad fa-times-square mr-3 text-warning"/>Přerušit zakázku
    </BDropdownItem>
</template>

<script>
import {mapGetters} from "vuex"

export default {

    computed: {
        ...mapGetters({
            order: 'order/getOrder',
            isProcessing: 'order/isProcessing',
        }),
    },

    methods: {

        process() {
            this.$bvModal.msgBoxConfirm('Opravdu chcete PŘERUŠIT tuto zakázku?', {
                title: 'Potvrzení',
                okVariant: 'primary',
                cancelVariant: 'default',
                centered: true,
                okTitle: "Ano, zrušit.",
                cancelTitle: "Ne"
            })
                .then(value => {
                    if (value === true) {
                        this.$store.dispatch("order/interruptOrder", this.order.id)
                            .then(() => {
                                this.successMessage('Zakázka byla úspěšně přerušena.')
                            })
                            .catch((error) => {
                                this.errorMessage(error.response.data.message)
                            })

                    }
                })
        },

    },

}
</script>
